import React from 'react';
import { Dumbbell, Mail, Globe } from 'lucide-react';
export function Footer() {
  return <footer className="bg-black border-t border-zinc-800 py-12 px-4" data-id="element-170">
      <div className="max-w-4xl mx-auto text-center" data-id="element-171">
        <div className="inline-flex items-center gap-2 mb-3" data-id="element-172">
          <Dumbbell className="w-5 h-5 text-primary" data-id="element-173" />
          <span className="font-space-grotesk font-extrabold text-white text-lg md:text-xl tracking-tight" data-id="element-174">
            COMPRA DIGITAL YA®
          </span>
        </div>

        <p className="text-sm md:text-base text-zinc-300 font-bold mb-2" data-id="element-175">
          El método N°1 de glúteos para mujeres argentinas · 30 Días de Glúteos
        </p>
        <p className="text-xs md:text-sm text-zinc-500 max-w-2xl mx-auto mb-8 leading-relaxed" data-id="element-176">
          Porque transformar tu cuerpo no debería costarte años sin resultados.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-6 text-xs md:text-sm text-zinc-400 mb-8" data-id="element-177">
          <a href="mailto:compradigitalyaa@gmail.com" className="flex items-center gap-1.5 hover:text-primary transition-colors" data-id="element-178">
            <Mail className="w-3.5 h-3.5" data-id="element-179" />
            compradigitalyaa@gmail.com
          </a>
          <span className="hidden sm:inline text-zinc-700" data-id="element-180">·</span>
          <a href="https://compradigitalya.com" className="flex items-center gap-1.5 hover:text-primary transition-colors" data-id="element-181">
            <Globe className="w-3.5 h-3.5" data-id="element-182" />
            www.compradigitalya.com
          </a>
        </div>

        <div className="pt-6 border-t border-zinc-800/60 text-[11px] md:text-xs text-zinc-600" data-id="element-183">
          © 2026 COMPRA DIGITAL YA — Todos los derechos reservados.
        </div>
      </div>
    </footer>;
}